import React from 'react';
import PropTypes from 'prop-types';
import Footer from './Footer';
import FooterSkeleton, {
	FooterSkeletonContainerClasses
} from '../skeleton/FooterSkeleton';

const FooterContainer = ({ shouldFullyRenderCard, ...props }) => (
	<div
		className={`vehicle-card-footer d-flex flex-wrap align-items-center${
			!shouldFullyRenderCard
				? ` ${FooterSkeletonContainerClasses.join(' ')}`
				: ''
		}`}
	>
		{shouldFullyRenderCard ? <Footer {...props} /> : <FooterSkeleton />}
	</div>
);

FooterContainer.propTypes = {
	shouldFullyRenderCard: PropTypes.bool.isRequired
};

export default FooterContainer;
